const findBarcode = item => {
  try {
    const totalpost = item.factor.serviceNumberParcel;
    if (totalpost) return totalpost;

    const internalOrder = item.parts[0].serviceNumberParcel;
    if (internalOrder) return internalOrder;

    const internalOrderPart = item.parts[0].servicePartnumber;
    if (internalOrderPart) return internalOrderPart;

    return "";
  } catch (error) {
    return "";
  }
};

export default findBarcode;
